/* Fills the space between the mascot and the menu button, so the button
 * stays at the right edge however long the section name is. */
.label {
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 4px;
  padding-left: 12px;
  border-left: var(--outline);
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (min-width: 720px) {
  .label {
    display: none;
  }
}
